import TwoColLayout from '../layouts/TwoCol';
import AuthContextProvider, { useAuthContext } from '../context/AuthContext';
import SignInSignUpToggle from '../common/SignInSignUpToggle';
import AuthForm from '../form';
import { FormGroup } from '../../generic/Forms';
import type { RouterProps } from '../../../types';

const Register = () => {
  const {
    email: {
      ref: emailInputRef,
      ...email
    },
    password: {
      ref: passwordInputRef,
      ...password
    },
    alert,
    status,
    hasInvite,
    orgTitle,
    passwordStrength,
    hidePasswordInput,
    step,
    page,
    inviteToken,
    submitButton,
    loginMethods,
  } = useAuthContext();

  return (
    <TwoColLayout>
      <AuthForm.Container onSubmit={submitButton.onSubmit}>
        <AuthForm.Heading heading={orgTitle ? 'Sign Up and join' : 'Sign Up'} orgTitle={orgTitle} />
        <AuthForm.Alert
          alert={alert}
          status={status}
          email={email.value}
        />
        <FormGroup>
          <AuthForm.EmailInput
            ref={emailInputRef}
            email={email}
            hasInvite={hasInvite}
            hidePasswordInput={hidePasswordInput}
            step={step}
            onSubmit={submitButton.onSubmit}
          />
          <AuthForm.PasswordInput
            ref={passwordInputRef}
            password={password}
            hidePasswordInput={hidePasswordInput}
            step={step}
            passwordStrength={passwordStrength}
            onSubmit={submitButton.onSubmit}
          />
        </FormGroup>
        <AuthForm.PasswordStrengthMeter
          step={step}
          hidePasswordInput={hidePasswordInput}
          passwordStrength={passwordStrength}
        />
        <AuthForm.SubmitButton
          page={page}
          step={step}
          status={status}
          submitButton={submitButton}
          hidePasswordInput={hidePasswordInput}
        />
        <AuthForm.TermsLink />
        <AuthForm.LoginMethods
          loginMethods={loginMethods}
          hidePasswordInput={hidePasswordInput}
          inviteToken={inviteToken}
          page={page}
        />
      </AuthForm.Container>
      <SignInSignUpToggle
        page="register"
        email={email.value}
      />
    </TwoColLayout>
  );
};

type RegisterProps = {
  location: RouterProps['location'];
};

/**
 * Register page for Auth 2.0
 */
const RegisterPage = ({ location }: RegisterProps) => (
  <AuthContextProvider
    location={location}
    inviteToken={location.query?.inviteToken}
  >
    <Register />
  </AuthContextProvider>
);

export default RegisterPage;
